export const prodMapTile = process.env.REACT_APP_PROD_TILE_LAYER;

export const MONGO_URI = process.env.REACT_APP_MONGO_URI;